import { useState } from "react";
import useGlobalProvider from "../../../lib/providers/globalProvider";
import {
  useCimiteriAree,
  useCimiteriTipologiaLampade,
} from "../../../lib/hooks/api/cimiteri";
import SelectField from "../FormFields/SelectField";

function CimiteroAree({
  field,
  handleOnChange,
  isSingleSelect,
  isClearable = true,
  compressed = false,
  fullWidth = false,
  append = null,
  helpText = null,
  showPlaceholder = true,
  additionalQuery = {},
}) {
  const { currentComuneId } = useGlobalProvider();
  const [searchQuery, setSearchQuery] = useState({});
  const { aree, isFetching, isLoading } = useCimiteriAree(
    currentComuneId,
    { ...searchQuery, ...additionalQuery },
    false
  );

  return (
    <SelectField
      field={field}
      isSingleSelect={isSingleSelect}
      handleOnChange={handleOnChange}
      options={aree.map((area) => ({
        code: area.label,
        label: `${area.label} - ${area.cimitero}`,
      }))}
      isClearable={isClearable}
      compressed={compressed}
      fullWidth={fullWidth}
      isLoading={isFetching || isLoading}
      append={append}
      helpText={helpText}
      showPlaceholder={showPlaceholder}
    />
  );
}

export default CimiteroAree;
